import React from "react";
import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NotificationsRounded from "@mui/icons-material/NotificationsRounded";
import MainLayout from "../../layouts/main/main_layout";
import AccessDenied from "../../components/access_denied/access_denied";
import useUser from "../../providers/user/user_provider";
import { NotificationList } from "./components/view-notifications";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";

const TAB_SUBTITLES = [
  "Manage and track notifications sent to app users.",
  "Manage notifications scheduled to be sent later.",
];

export default function Notifications() {
  const [searchParams, setUrlParam] = useSearchParams();
  const [page, setPage] = useState(
    searchParams?.has("page") ? parseInt(searchParams.get("page")!) : 1
  );
  const [currentTab, setCurrentTab] = useState(
    searchParams.has("currentTab") ? +searchParams.get("currentTab")! : 0
  );
  const { hasPermission } = useUser();

  useEffect(() => {
    setUrlParam({ page: page.toString(), currentTab: currentTab.toString() });
  }, []);

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
    setUrlParam((prev) => {
      const params = new URLSearchParams(prev);
      params.set("currentTab", currentTabVal.toString());
      return params;
    }, { replace: true });
  };

  function renderComponentBasedOnTabIndex() {
    switch (currentTab) {
      case 0:
        return <NotificationList key="notifications" />;
      case 1:
        return <NotificationList key="scheduled-notifications" isScheduledView />;
      default:
        return null;
    }
  }

  return (
    <MainLayout>
      {hasPermission("notifications", "read") ? (
        <Box>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                borderRadius: 2,
                bgcolor: purpleLight,
                flexShrink: 0,
              }}
            >
              <NotificationsRounded sx={{ color: purple, fontSize: 24 }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={700} color={black}>
                Notifications
              </Typography>
              <Typography variant="body2" color={greyEnabled} mt={0.5}>
                {TAB_SUBTITLES[currentTab]}
              </Typography>
            </Box>
          </Box>

          <Card
            elevation={0}
            sx={{
              display: "flex",
              mt: 2,
              width: "100%",
              minHeight: 600,
              mb: 2,
              borderRadius: 3,
              border: "1px solid #ECECEC",
            }}
          >
            <Box display="flex" flexDirection="column" sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: "1px solid #ECECEC", px: 3, pt: 1 }}>
                <Tabs
                  value={currentTab}
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: { backgroundColor: purple, height: 3, borderRadius: 3 },
                  }}
                >
                  <Tab
                    value={0}
                    label="Notifications"
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      color: greyEnabled,
                      "&.Mui-selected": { color: purple },
                    }}
                  />
                  <Tab
                    value={1}
                    label="Scheduled Notifications"
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      color: greyEnabled,
                      "&.Mui-selected": { color: purple },
                    }}
                  />
                </Tabs>
              </Box>
              {renderComponentBasedOnTabIndex()}
            </Box>
          </Card>
        </Box>
      ) : (
        <Box display="flex" flex={1} width="100%" height="100%">
          <AccessDenied />
        </Box>
      )}
    </MainLayout>
  );
}
